<template>
  <odd-page title="Email Editor" :subtitle="name">
    <template v-slot:header>
      <div class="w-100 d-flex flex-row justify-content-end align-items-center">
        <d-dropdown
          theme="dark"
          size="sm"
          noCaret
          class="mx-2 radius"
          round
          right
          closeOnClick
        >
          <template v-slot:button-content>
            <i class="material-icons">more_horiz</i>
          </template>
          <template>
            <d-dropdown-item
              v-if="uses_post_purchase_content"
              @click="handleEditPostPurchaseContent()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Post Purchase Page
            </d-dropdown-item>
            <d-dropdown-item
              v-if="uses_customizations"
              @click="handleEditCustomizations()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Customizations
            </d-dropdown-item>
            <d-dropdown-item
              @click="handleEditProduct()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Product
            </d-dropdown-item>
          </template>
        </d-dropdown>
      </div>
    </template>
    <template>
      <d-container>
        <d-row>
          <d-col cols="12" xl="8" class="product-email-editor-container">
            <EmailEditor
              v-if="this.data !== null"
              :onSave="handleOnSave"
              :data="data"
              editorType="email"
            />
          </d-col>
          <d-col cols="12" xl="4">
            <div class="">
              <p class="h6 py-2">
                Reference the customer, and their order details by including the
                following string/text within your email template
              </p>
              <table class="table w-100">
                <tbody>
                  <tr v-for="t in templateTags" :key="t.tag">
                    <td>
                      <kbd
                        @click="copyToClipboard(t.tag)"
                        class="cursor-pointer"
                        title="Click to copy"
                        >{{ t.tag }}</kbd
                      >
                    </td>
                    <td class="w-100">
                      {{ t.description }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </d-col>
        </d-row>
      </d-container>
    </template>
  </odd-page>
</template>

<script>
import EmailEditor from "../../components/EmailEditor";
import Page from "@/components/layout/Page/Page.vue";

export default {
  data() {
    return {
      data: null,
      templateTags: [
        { tag: "{{customer.name}}", description: "The name of the customer" },
        {
          tag: "{{customer.address}}",
          description: "The customer's address"
        },
        { tag: "{{customer.city}}", description: "The customer's city" },
        { tag: "{{customer.state}}", description: "The customer's state" },
        {
          tag: "{{customer.zip}}",
          description: "The customer's 5 digit zip code"
        },
        {
          tag: "{{order.created_at}}",
          description: "The date and time that the order was created"
        },
        {
          tag: "{{order.pickup.datetime}}",
          description:
            "The date and time that the customer has scheduled to pickup the order"
        },
        {
          tag: "{{order.grand_total}}",
          description: "The grand total of the order in USD"
        },
        {
          tag: "{{order.item.name}}",
          description: "The name of the item that the customer purchased"
        },
        {
          tag: "{{order.item.quantity}}",
          description: "The quantity/amount that the customer ordered"
        }
      ]
    };
  },
  created() {
    this.$store.dispatch("products/get", this.$route.params.key);
    this.$store
      .dispatch("products/getContent", this.$route.params.key)
      .then(data => {
        this.data = data.post_purchase_email_body;
      });
  },
  computed: {
    name() {
      return !!this.$store.state.products.editProduct
        ? this.$store.state.products.editProduct.name
        : "  ";
    },
    uses_post_purchase_content() {
      return this.$store.getters["settings/uses_post_purchase_content"];
    },
    uses_customizations() {
      return this.$store.getters["settings/uses_customizations"];
    }
  },
  components: { EmailEditor, "odd-page": Page },
  methods: {
    copyToClipboard(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$toasted.show(`Copied ${str} to clipboard`, {
        position: "bottom-right",
        duration: 2000
      });
    },
    handleOnSave(content) {
      const updatedContent = {
        key: this.$route.params.key,
        post_purchase_email_body: content
      };
      this.$store
        .dispatch("products/updateContent", updatedContent)
        .then(data => {});
    },
    handleEditProduct() {
      this.$router.push({
        name: "products__edit",
        params: { key: this.$route.params.key }
      });
    },
    handleEditPostPurchaseContent() {
      this.$router.push({
        name: "products__edit__post_purchase_content",
        params: { key: this.$route.params.key }
      });
    },
    handleEditCustomizations() {
      this.$router.push({
        name: "products__edit__customizations",
        params: { key: this.$route.params.key }
      });
    }
  }
};
</script>

<style scoped>
.product-email-editor-container {
  max-width: 850px !important;
}
</style>
